<template>
  <svg width="20" height="20" aria-hidden="true" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="Icon Icon--place ">
    <path d="M16.25 9.99994C16.25 14.1082 11.8355 16.9028 10.4267 17.69C10.1595 17.8393 9.84048 17.8393 9.57334 17.69C8.16447 16.9028 3.75 14.1082 3.75 9.99994C3.75 6.24994 6.77834 3.74994 10 3.74994C13.3333 3.74994 16.25 6.24994 16.25 9.99994Z" stroke="currentColor"></path>
    <circle cx="9.99935" cy="9.99994" r="2.83333" stroke="currentColor"></circle>
  </svg>
</template>